import {
  Wrapper,
  Description,
  IconWrapper,
  Title,
  TitleDescriptionWrapper,
} from "./styles";
import React from "react";

type Coordinates = {
  x: string;
  y: string;
};

type AdvantageCard = {
  title: string;
  description: string;
  icon: JSX.Element;
  color: string;
  coordinates: Coordinates;
};

function AdvantageCard({
  title,
  description,
  color,
  icon,
  coordinates,
}: AdvantageCard) {
  return (
    <Wrapper style={{ top: coordinates.y, left: coordinates.x }}>
      <IconWrapper style={{ background: color, color: "white" }}>{icon}</IconWrapper>
      <TitleDescriptionWrapper>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TitleDescriptionWrapper>
    </Wrapper>
  );
}

export default AdvantageCard;
